import { useMutation } from '@tanstack/react-query';
import { passwordReset } from '../services/auth';
import type { ResetPasswordRequest, LogoutResponse } from '../services/auth';

export const useResetPassword = () => {
    return useMutation<LogoutResponse, Error, ResetPasswordRequest>({
        mutationFn: (payload) => passwordReset(payload),
    });
};
